export default "__VITE_ASSET__BomwJX8$__"